var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start-header relative px-3"
  }, [_c('div', {
    staticClass: "start-header-bg",
    style: {
      'background-color': _vm.bg.color
    }
  }, [_c('div', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "2",
      "background": "linear-gradient(#EDF6FC, transparent)"
    }
  }), _c('card-background', {
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "src": _vm.bg.src
    },
    on: {
      "loaded": function ($event) {
        return _vm.$emit('loaded-bg');
      }
    }
  })], 1), _c('div', {
    staticClass: "mx-auto py-6 py-sm-9 py-md-12 white--text text-shadow",
    staticStyle: {
      "max-width": "1264px"
    }
  }, [_c('div', {
    staticClass: "d-lg-flex flex-row-reverse align-center"
  }, [_vm.media ? _c('outline-laptop', {
    staticClass: "header-laptop flex-shrink-0 mx-auto mb-6"
  }, [_c('web-media', {
    staticStyle: {
      "aspect-ratio": "16 / 9"
    },
    attrs: {
      "eager": "",
      "max": "md",
      "id": _vm.media.id,
      "alt": _vm.media.alt,
      "is-video": _vm.media.video
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mx-auto text-center text-lg-right"
  }, [_c('h1', {
    staticClass: "header-font text-h4 text-md-h3 text-lg-h2"
  }, [_vm._t("h1")], 2), _vm._t("append-h1")], 2)], 1), _vm.$slots.h2 ? _c('h2', {
    staticClass: "mt-6 mt-lg-12 header-font text-h6 text-md-h5 text-lg-h4 text-center"
  }, [_vm._t("h2")], 2) : _vm._e()]), _vm._t("append-inner")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }